import { createContext, useContext } from 'react';
import { useFormContext } from 'react-hook-form';

type SankeyFormAdditionalState = {
  canUpdate: boolean;
  isErrorFetching: boolean;
  isFetching: boolean;
  isLoading: boolean;
  isReadOnly: boolean;
};

export const SankeyFormAdditionalContext =
  createContext<SankeyFormAdditionalState>({
    canUpdate: false,
    isErrorFetching: false,
    isFetching: false,
    isLoading: false,
    isReadOnly: true,
  });

export const useSankeyFormContext = () => {
  const form = useFormContext<SankeyFormValues>();
  const formAdditionalContext = useContext(SankeyFormAdditionalContext);
  return { form, ...formAdditionalContext };
};
